[
  {
    "id": "dawnmere",
    "name": "Dawnmere",
    "description": "A quiet farming village at the edge of the kingdom. You are no one of note here — just another villager among the harvest and the herd — where your story begins.",
    "position": { "x": 48, "y": 45 },
    "factionId": "humans",
    "connections": ["dawnmere_to_crossroads", "dawnmere_to_goldenfields"]
  },
  {
    "id": "kings_road_crossroads",
    "name": "King's Road Crossroads",
    "description": "A well-traveled crossroads connecting Dawnmere to the fortress, the ruined temple, and the road east to Crownreach.",
    "position": { "x": 38, "y": 42 },
    "factionId": null,
    "connections": [
      "dawnmere_to_crossroads",
      "crossroads_to_ironwatch",
      "crossroads_to_ruined_temple",
      "crossroads_to_crownreach"
    ]
  },
  {
    "id": "ironwatch_fortress",
    "name": "Ironwatch Fortress",
    "description": "A kingdom military stronghold guarding the road against orc incursions from the wastes to the west.",
    "position": { "x": 34, "y": 23 },
    "factionId": "humans",
    "connections": [
      "crossroads_to_ironwatch",
      "ironwatch_to_blacktooth_wastes",
      "ironwatch_to_starbow_academy"
    ]
  },
  {
    "id": "ruined_temple_first_dawn",
    "name": "Ruined Temple of the First Dawn",
    "description": "The crumbled remains of an ancient temple, hiding forgotten knowledge — and, when the wardens keep their watch here, the nearest place the Good Spirits will meet the living.",
    "position": { "x": 38, "y": 58 },
    "factionId": "good_spirits",
    "connections": ["crossroads_to_ruined_temple", "temple_to_whispering_lake"]
  },
  {
    "id": "crownreach",
    "name": "Crownreach",
    "description": "The kingdom's capital, seat of the crown, its towers visible for miles along the King's Road.",
    "position": { "x": 59, "y": 29 },
    "factionId": "humans",
    "connections": ["crossroads_to_crownreach", "crownreach_to_rivergate", "crownreach_to_deepgate"]
  },
  {
    "id": "goldenfields",
    "name": "Goldenfields",
    "description": "Fertile farmland feeding the kingdom's heartland, its fields golden and undefended.",
    "position": { "x": 47, "y": 55 },
    "factionId": "humans",
    "connections": ["dawnmere_to_goldenfields"]
  },
  {
    "id": "rivergate",
    "name": "Rivergate",
    "description": "A river city and trade hub downstream from the capital, its docks thick with news from every road — including the ones no map in the heartland bothers to draw.",
    "position": { "x": 57, "y": 55 },
    "factionId": "humans",
    "connections": ["crownreach_to_rivergate", "rivergate_to_sevenfold_tower", "rivergate_to_windroad_market"]
  },
  {
    "id": "moonspire",
    "name": "Moonspire",
    "description": "Capital of the High Elf Realm, rising in tiers of pale stone and silver light above the northern hills.",
    "position": { "x": 37, "y": 6 },
    "factionId": "high_elves",
    "connections": ["starbow_to_moonspire"],
    "requiresTrust": { "factionId": "high_elves", "level": "recognized" }
  },
  {
    "id": "starbow_academy",
    "name": "Starbow Academy",
    "description": "A High Elf military academy where recruits drill in near-silence, more discipline than spectacle.",
    "position": { "x": 30, "y": 14 },
    "factionId": "high_elves",
    "connections": [
      "ironwatch_to_starbow_academy",
      "starbow_to_moonspire",
      "starbow_to_cloudwood_aerie"
    ]
  },
  {
    "id": "cloudwood_aerie",
    "name": "Cloudwood Aerie",
    "description": "A High Elf watch post clinging to a cliff face above the cloud line, tracking everything that moves across the lowlands below — and, on the clearest days, the red glow of Cinderpeak away to the west.",
    "position": { "x": 15, "y": 24 },
    "factionId": "high_elves",
    "connections": ["starbow_to_cloudwood_aerie", "cloudwood_to_thornwatch", "cloudwood_to_cinderpeak"]
  },
  {
    "id": "stonehall",
    "name": "Stonehall",
    "description": "Capital of the Dwarven Realm, a hall cut into living rock where Thane Durn holds a court that has not marched to anyone's war in a generation.",
    "position": { "x": 70, "y": 21 },
    "factionId": "dwarves",
    "connections": ["deepgate_to_stonehall", "stonehall_to_emberforge"]
  },
  {
    "id": "emberforge",
    "name": "Emberforge",
    "description": "A dwarven forge-city of perpetual furnace-light, estranged from Stonehall over an old debt of iron, and the last hold before the passes climb into Colossus Vale.",
    "position": { "x": 90, "y": 11 },
    "factionId": "dwarves",
    "connections": ["stonehall_to_emberforge", "emberforge_to_colossus_vale"]
  },
  {
    "id": "deepgate",
    "name": "Deepgate",
    "description": "The great underground gate into the Dwarven Realm, where the mountain roads meet the surface world and every visitor is weighed before being let below.",
    "position": { "x": 67, "y": 36 },
    "factionId": "dwarves",
    "connections": ["crownreach_to_deepgate", "deepgate_to_stonehall", "deepgate_to_glass_library"]
  },
  {
    "id": "greenveil",
    "name": "Greenveil",
    "description": "Capital city of the Wood Elf Realm, a place more grown than built, where Warden Sylvaine keeps a court that cannot decide whether the wider world is worth saving.",
    "position": { "x": 23, "y": 48 },
    "factionId": "wood_elves",
    "connections": ["thornwatch_to_greenveil", "greenveil_to_elderroot_grove", "greenveil_to_whispering_lake"]
  },
  {
    "id": "elderroot_grove",
    "name": "Elderroot Grove",
    "description": "A sacred grove of the Wood Elves, where the oldest elders counsel keeping the forest whole and letting the outer kingdoms burn.",
    "position": { "x": 11, "y": 68 },
    "factionId": "wood_elves",
    "connections": ["greenveil_to_elderroot_grove"]
  },
  {
    "id": "thornwatch",
    "name": "Thornwatch",
    "description": "A Wood Elf ranger outpost on the forest's northern edge, whose scouts strain against the elders' caution and want to march.",
    "position": { "x": 27, "y": 38 },
    "factionId": "wood_elves",
    "connections": ["cloudwood_to_thornwatch", "thornwatch_to_greenveil"]
  },
  {
    "id": "sevenfold_tower",
    "name": "Sevenfold Tower",
    "description": "The mage-citadel of the Spellcasters, seven spires braided into one, where Archmagister Vaeloth presides over two orders that cannot agree how the world ends.",
    "position": { "x": 66, "y": 47 },
    "factionId": "spellcasters",
    "connections": ["rivergate_to_sevenfold_tower", "sevenfold_to_glass_library"]
  },
  {
    "id": "glass_library",
    "name": "Glass Library",
    "description": "A vast repository of arcane research under panes of enchanted glass, home to the ritualists who unmake bindings.",
    "position": { "x": 77, "y": 43 },
    "factionId": "spellcasters",
    "connections": ["sevenfold_to_glass_library", "deepgate_to_glass_library", "glass_library_to_rift_observatory"]
  },
  {
    "id": "rift_observatory",
    "name": "Rift Observatory",
    "description": "An observatory perched to watch the Shattered Veil across the wastes, staffed by the fire-handlers and storm-callers who study the tear from a careful distance.",
    "position": { "x": 93, "y": 54 },
    "factionId": "spellcasters",
    "connections": ["glass_library_to_rift_observatory", "rift_observatory_to_shattered_veil"]
  },
  {
    "id": "camp_seven_banners",
    "name": "Camp of Seven Banners",
    "description": "The gathered war-camp of the Nomad clans, seven standards planted in a ring, where Khan Aytolga leads one banner and commands none of the others.",
    "position": { "x": 59, "y": 62 },
    "factionId": "nomads",
    "connections": ["windroad_to_camp_seven_banners", "camp_to_red_steppe", "camp_to_mire_hunger"]
  },
  {
    "id": "windroad_market",
    "name": "Windroad Market",
    "description": "A great trade market on the nomad plains where the clans argue their endless succession between rounds of horse-trading.",
    "position": { "x": 52, "y": 62 },
    "factionId": "nomads",
    "connections": ["rivergate_to_windroad_market", "hall_ancestors_to_windroad_market", "windroad_to_camp_seven_banners"]
  },
  {
    "id": "red_steppe",
    "name": "The Red Steppe",
    "description": "Open ochre wilderness at the southern reach of the nomad lands, a crossing few but the horse-clans dare, giving onto the Nightweb's ground and the far demon wastes.",
    "position": { "x": 65, "y": 65 },
    "factionId": "nomads",
    "connections": ["camp_to_red_steppe", "red_steppe_to_nightweb", "red_steppe_to_shattered_veil"]
  },
  {
    "id": "whispering_lake",
    "name": "Whispering Lake",
    "description": "A still, pale water sacred to the Good Spirits, where the Pale Sister keeps a watch on the dead that the living could never keep alone.",
    "position": { "x": 26, "y": 63 },
    "factionId": "good_spirits",
    "connections": ["temple_to_whispering_lake", "greenveil_to_whispering_lake", "whispering_lake_to_hall_ancestors"]
  },
  {
    "id": "hall_ancestors",
    "name": "Hall of Ancestors",
    "description": "A hushed sanctuary of the Good Spirits' honoured dead, whose shades would see the Necromancer's works unmade to the last bone.",
    "position": { "x": 47, "y": 69 },
    "factionId": "good_spirits",
    "connections": ["whispering_lake_to_hall_ancestors", "hall_ancestors_to_windroad_market", "hall_ancestors_to_ashen_necropolis"]
  },
  {
    "id": "blacktooth_wastes",
    "name": "Blacktooth Wastes",
    "description": "An orc stronghold in the wastes west of Ironwatch, its war-camps visible from a safe distance if you're careful.",
    "position": { "x": 58, "y": 14 },
    "factionId": "orcs",
    "connections": ["ironwatch_to_blacktooth_wastes"]
  },
  {
    "id": "colossus_vale",
    "name": "Colossus Vale",
    "description": "A high, cold valley of the Giants, where Jarnsmiter's warband walks a country too big for caution to have ever seemed worth learning.",
    "position": { "x": 73, "y": 5 },
    "factionId": "giants",
    "connections": ["emberforge_to_colossus_vale"]
  },
  {
    "id": "cinderpeak",
    "name": "Cinderpeak",
    "description": "A volcanic spire wreathed in ash, roost of the dragon Vharethyx, from which it descends when something below is worth burning.",
    "position": { "x": 15, "y": 9 },
    "factionId": "dragons",
    "connections": ["cloudwood_to_cinderpeak"]
  },
  {
    "id": "mire_hunger",
    "name": "Mire of Hunger",
    "description": "A fetid troll-mire that eats everything that wanders into it, ruled by a Mother who has never known a full season.",
    "position": { "x": 62, "y": 78 },
    "factionId": "trolls",
    "connections": ["camp_to_mire_hunger"]
  },
  {
    "id": "ashen_necropolis",
    "name": "Ashen Necropolis",
    "description": "A grey city of the standing dead, held upright by a great anchor driven into old ground — the Necromancer's northern muster.",
    "position": { "x": 48, "y": 84 },
    "factionId": "undead",
    "connections": ["hall_ancestors_to_ashen_necropolis"]
  },
  {
    "id": "nightweb_underrealm",
    "name": "Nightweb Underrealm",
    "description": "A lightless warren of the Dark Elves beneath the southern steppe, where Matron Vess sells her killers to whoever pays in coin or fear.",
    "position": { "x": 65, "y": 86 },
    "factionId": "dark_elves",
    "connections": ["red_steppe_to_nightweb", "nightweb_to_ebon_citadel"]
  },
  {
    "id": "shattered_veil",
    "name": "The Shattered Veil",
    "description": "A tear in the world at the edge of the demon wastes, through which things come for as long as the anchor holds it open.",
    "position": { "x": 82, "y": 78 },
    "factionId": "demon_spirits",
    "connections": ["rift_observatory_to_shattered_veil", "red_steppe_to_shattered_veil", "shattered_veil_to_ebon_citadel"]
  },
  {
    "id": "ebon_citadel",
    "name": "Ebon Citadel",
    "description": "The Necromancer's final stronghold in the far corner of the world, behind an army and a gate, where the ritual to extinguish the sun is being worked toward its five hundred and twelfth day.",
    "position": { "x": 93, "y": 91 },
    "factionId": "necromancer",
    "connections": ["shattered_veil_to_ebon_citadel", "nightweb_to_ebon_citadel"]
  }
]
